import React from "react";
export default function WebSearchTool({ payload, result }) {
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Query</h5>
        <pre className="tool-pre">{payload?.input?.query || ""}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Results</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
        </div>
      )}
    </div>
  );
}
WebSearchTool.summarize = (p) => p?.input?.query || "";
